export default "__VITE_ASSET__9312d2d9__"